import ScrollSlideRight from "@/components/shared/animations/ScrollSlideRight"

const StepsNumbers = () => {
    return (

        <div className="w-full">
            <ScrollSlideRight>
                <div className="flex flex-col md:flex-row w-1/2 md:w-full items-center md:justify-center">
                    {["1", "2", "3", "4"].map((num, index, arr) => (
                        <div key={num} className="flex flex-col md:flex-row justify-center items-center w-full">
                            <div className="flex items-center justify-center w-16 h-16 rounded-full text-white bg-primary aspect-square">
                                <span className="text-xl font-bold">{num}</span>
                            </div>
                            <div className="h-[100px] md:w-full md:h-0.5 border-dashed border-2 border-primary"></div>
                        </div>
                    ))}
                    <div className="flex items-center">
                        <div className="w-4 h-4 bg-primary rounded-full"></div>
                    </div>
                </div>
            </ScrollSlideRight>
        </div>

    )
}

export default StepsNumbers